module.exports = __webpack_public_path__ + "static/media/games-icon.6158b362.svg";